const dateTime = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
const dateOnly = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
const timeOnly = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
const relative = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })

export const formatDateTime = (value: string | number | Date) => dateTime.format(new Date(value))
export const formatDate = (value: string | number | Date) => dateOnly.format(new Date(value))
export const formatClock = (value: string | number | Date) => timeOnly.format(new Date(value))

/** `3 minutes ago`, `yesterday`; older dates fall back to the plain date. */
export function formatRelative(value: string | number | Date, now = Date.now()): string {
  const diff = new Date(value).getTime() - now
  const abs = Math.abs(diff)
  if (abs < 45_000) return 'just now'
  if (abs < 3_600_000) return relative.format(Math.round(diff / 60_000), 'minute')
  if (abs < 86_400_000) return relative.format(Math.round(diff / 3_600_000), 'hour')
  if (abs < 7 * 86_400_000) return relative.format(Math.round(diff / 86_400_000), 'day')
  return formatDate(value)
}

export const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

/** `Anna, Ben and Chris` */
export function listNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? ''
  return `${names.slice(0, -1).join(', ')} and ${names.at(-1)}`
}
